import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    width: props.width,
    padding: "0 10px",
    display: "flex",
  }),
  input: {
    width: "8.5rem",
    border: theme.shape.border,
    paddingLeft: 7,
    paddingTop: 7,
    paddingRight: 7,
    paddingBottom: 3,
  },
  grow: {
    flexGrow: 1,
  },
  flex: {
    display: "flex",
  },
  leftInput: {
    textAlign: "left",
  },
  rightInput: {
    textAlign: "right",
  },
  clearAllFilters: {
    position: "absolute",
    right: 30,
  },
}));
